<div class="modal-header">
    <div class="">
        <h4 class="mb-1 text-strong">Assign User to:</h4>
        <nav aria-label="breadcrumb" class="small">
            <ol class="breadcrumb mb-0">
                <li class="breadcrumb-item" *ngFor="let h of assignment.hierarchy"><i class="far fa-folder"></i>
                    {{h.text}}</li>
            </ol>
        </nav>
    </div>
    <button type="button" class="btn-close" (click)="dismiss()" aria-label="Close"></button>
</div>
<div class="modal-body">
    <ng-container [ngSwitch]="stepNumber">
        <p class="m-0" *ngSwitchCase="2"><i class="far fa-user"></i> User: {{assignment.user.emailAddress}}</p>
        <hr *ngSwitchCase="2" />
        <p class="m-0" *ngSwitchCase="3"><i class="far fa-user"></i> User: {{assignment.user.firstName}}
            {{assignment.user.lastName}} -
            {{assignment.user.emailAddress}}</p>
        <hr *ngSwitchCase="3" />
        <p class="m-0" *ngSwitchCase="4"><i class="far fa-user"></i> User: {{assignment.user.firstName}}
            {{assignment.user.lastName}} -
            {{assignment.user.emailAddress}}</p>
        <hr *ngSwitchCase="4" />
    </ng-container>
    <dirty-tracking [forms]="[assignmentForm]"></dirty-tracking>
    <form novalidate #assignmentForm="ngForm" [ngClass]="{'was-validated': submitAttempt}" [ngSwitch]="stepNumber">
        <div class="row gx-2 mb-4" *ngSwitchCase="1">
            <div class="col-md mb-3 mb-md-0 mobiscroll-select">
                <label class="form-label d-block">User Email Address <sup class="text-danger">*</sup></label>
                <input id="move-account-input" class="form-control form-control-lg" required placeholder="Email Address" [ngbTypeahead]="searchEmailAddress" (selectItem)="selectEmailAddress($event)" name="userEmailAddress" [(ngModel)]="assignment.user.emailAddress" [resultFormatter]="formatter" [inputFormatter]="formatter" />
                <div class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
        <h5 class="mb-3 text-medium" *ngSwitchCase="2">New User Profile:</h5>
        <div class="row gx-2 mb-4" *ngSwitchCase="2">
            <div class="col-md mb-3">
                <label for="userFirstName" class="form-label">First Name<sup class="text-danger">*</sup></label>
                <input type="text" class="form-control form-control-lg" id="userFirstName" placeholder="First Name" required name="userFirstName" [(ngModel)]="assignment.user.firstName">
                <div class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
            <div class="col-md mb-3">
                <label for="userLastName" class="form-label">Last Name<sup class="text-danger">*</sup></label>
                <input type="text" class="form-control form-control-lg" id="userLastName" placeholder="Last Name" required name="userLastName" [(ngModel)]="assignment.user.lastName">
                <div class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
        <div class="row gx-2 mb-4" *ngSwitchCase="2">
            <div class="col-md mb-3">
                <label for="userTitle" class="form-label">Title</label>
                <input type="text" class="form-control form-control-lg" id="userTitle" placeholder="Title" name="userTitle" [(ngModel)]="assignment.user.title">
            </div>
            <div class="col-md mb-3">
                <label for="userPhone" class="form-label">Phone</label>
                <input type="phone" class="form-control form-control-lg" id="userPhone" placeholder="Phone" name="userPhone" [(ngModel)]="assignment.user.phoneNumber">
            </div>
        </div>
        <div class="row gx-2 mb-4" *ngSwitchDefault>
            <h5 class="mb-2">Assign User...</h5>
            <div class="row gx-2 mb-4">
                <div class="col">
                    <button type="button" class="btn btn-outline-black btn-lg w-100" [ngClass]="{'active': !assignment.passToChildren}" (click)="assignment.passToChildren = false">Only Here</button>
                </div>
                <div class="col">
                    <button type="button" class="btn btn-outline-black btn-lg w-100" [ngClass]="{'active': assignment.passToChildren}" (click)="assignment.passToChildren = true">To
                        All Inherited
                        Entities</button>
                </div>
            </div>
            <h5 class="mb-3 text-medium" *ngIf="assignment.hierarchy.length > 0">Set this user's permissions for all
                entities
                under<br />"{{assignment.hierarchy[assignment.hierarchy.length - 1].text}}"
            </h5>
            <input type="text" name="permissions" class="mobi-input form-control form-control-lg" mbsc-select required [data]="permissions" [(ngModel)]="assignment.permissions" [mbscOptions]="permissionOptions" />
            <div class="invalid-feedback">
                <i class="fas fa-exclamation-circle"></i> This field is required.
            </div>
        </div>
    </form>
</div>
<div class="modal-footer" [ngSwitch]="stepNumber">
    <button type="button" class="btn btn-secondary btn-round btn-lg" *ngSwitchCase="1" (click)="nextStep()">Continue <i class="far fa-arrow-right"></i></button>
    <button type="button" class="btn btn-outline-black btn-round btn-lg" *ngSwitchCase="2" (click)="previousStep()"><i class="far fa-chevron-left"></i> back</button>
    <button type="button" class="btn btn-secondary btn-round btn-lg" *ngSwitchCase="2" (click)="nextStep()">Continue <i class="far fa-arrow-right"></i></button>
    <button type="button" class="btn btn-outline-black btn-round btn-lg" *ngSwitchCase="3" (click)="previousStep()"><i class="far fa-chevron-left"></i> back</button>
    <button type="button" class="btn btn-secondary btn-round btn-lg" *ngSwitchCase="3" (click)="saveAssignment()"><i class="far fa-check"></i> Assign User</button>
    <button type="button" class="btn btn-secondary btn-round btn-lg" *ngSwitchCase="4" (click)="saveAssignment()"><i class="far fa-check"></i> Assign User</button>
</div>